import ReactModal from 'react-modal';

import { ZoomComponentModalCloseButton } from '../activity-builder-zoom-component-modal';
import {
  SimpleModalContainerStyled,
  SimpleModalContentStyled,
} from 'lib/modal/simple-modal.styles';
import { Props } from 'lib/modal/simple-modal';
import { ModalBaseCss } from 'lib/modal/modal.constants';
import { spacing16 } from 'approot/shared/styles/spacing.style';

const ActivityPresentModal = ({
  children,
  size,
  isFullWidth,
  isFullHeight,
  isCentered,
  isTransparent,
  title,
  scrollWithinModal,
  noPadding = false,
  onClose,
  ...rest
}: Props & {
  isFullWidth?: boolean;
  isFullHeight?: boolean;
  isCentered?: boolean;
  isTransparent?: boolean;
  noPadding?: boolean;
}) => {
  return (
    <ReactModal
      isOpen
      {...rest}
      onRequestClose={onClose}
      style={{
        ...ModalBaseCss,
        content: {
          ...ModalBaseCss.content,
          display: 'flex',
          flexDirection: 'column',
          inset: '20px auto auto',
          padding: `calc(${spacing16}px + env(safe-area-inset-left)`,
          maxWidth: isFullWidth ? '100%' : size ? `${size}px` : '1128px',
          width: isFullWidth ? '100vw' : undefined,
          height: isFullHeight ? '90vh' : undefined,
          ...(isCentered
            ? {
                inset: '50% auto auto',
                transform: 'translateY(-50%)',
              }
            : undefined),
        },
      }}
      contentLabel={title}
      bodyOpenClassName="ReactModal__Body--open"
    >
      {onClose && (
        <ZoomComponentModalCloseButton
          aria-label={`Close ${title}`}
          onClick={onClose}
        />
      )}

      <SimpleModalContainerStyled
        $scrollWithinModal
        $isOverflowable
        $isHeadless
        $isTransparent={isTransparent}
      >
        {noPadding ? (
          children
        ) : (
          <SimpleModalContentStyled>{children}</SimpleModalContentStyled>
        )}
      </SimpleModalContainerStyled>
    </ReactModal>
  );
};

export default ActivityPresentModal;
